export const colors = {
  darkBlue: "#3D405B",
  green: "#81B29A",
  yellow: "#F2CC8F",
  orange: "#E07A5F",
  whiteText: "#F4F1DE",
  headingBlue: "#1E234D",
  darkOrangeText: "#D15D3E",
  darkGreenText: "#6A9C84",
  darkBlueText: "#2B2D43",
};
